var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.748 10.654a4.328 4.328 0 000-8.654 4.328 4.328 0 000 8.654zm8.518 13.44l-2.1-1.063-.874-2.65c-1.326-4.021-5.021-6.834-9.213-6.842-3.245-.01-5.04.91-8.41 2.271a8.599 8.599 0 00-4.48 4.165L3.583 21.2c-.703 1.424-.135 3.155 1.28 3.867 1.407.712 3.12.135 3.831-1.29l.604-1.225a2.865 2.865 0 011.488-1.388l2.416-.974-1.37 5.472a5.79 5.79 0 001.343 5.3l5.4 5.896a5.818 5.818 0 011.342 2.497l1.65 6.607a2.89 2.89 0 003.498 2.1 2.89 2.89 0 002.1-3.497l-2.001-8.023a5.767 5.767 0 00-1.343-2.497l-4.102-4.48 1.55-6.193.496 1.488a5.749 5.749 0 002.858 3.335l2.1 1.064c1.407.712 3.12.135 3.831-1.29.695-1.415.127-3.163-1.289-3.876v0zM8.632 36.778a5.593 5.593 0 01-1.28 1.938l-4.507 4.516a2.889 2.889 0 000 4.084 2.878 2.878 0 004.075 0l5.354-5.355c.55-.55.983-1.208 1.28-1.938l1.217-3.047c-4.985-5.436-3.488-3.768-4.273-4.84l-1.866 4.642v0z",
    stroke: "#91C300",
    strokeWidth: 2.5
  })));
}

export default SvgWalk;